const KEY = 'dumbverse_visitor_token';
const NAME_KEY = 'dumbverse_display_name';

export const getVisitorToken = (): string => {
  let token = localStorage.getItem(KEY);
  if (!token || token.length < 8) {
    token = crypto.randomUUID().replace(/-/g, '');
    localStorage.setItem(KEY, token);
  }
  return token;
};

export const getSavedName = (): string => localStorage.getItem(NAME_KEY) ?? '';

export const saveName = (name: string) => {
  const trimmed = name.trim().slice(0, 40);
  if (trimmed) localStorage.setItem(NAME_KEY, trimmed);
  else localStorage.removeItem(NAME_KEY);
};
